import { useState } from "react";
import { useBudget } from "../context/BudgetContext";

export default function Settings() {
  const { transactions, categories, shareEnabled, shareToken, updateSharing } = useBudget();
  const [shareLoading, setShareLoading] = useState(false);
  const [copied, setCopied]           = useState(false);

  const shareUrl = shareToken ? `${window.location.origin}/share/${shareToken}` : null;

  const handleToggleShare = async () => {
    setShareLoading(true);
    await updateSharing(!shareEnabled);
    setShareLoading(false);
  };

  const handleCopy = () => {
    if (!shareUrl) return;
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const stats = [
    { label: "TRANSACTIONS", value: transactions.length },
    { label: "CATEGORIES", value: categories.length },
    { label: "TOTAL_RECORDED", value: `$${transactions.reduce((s, t) => s + Number(t.amount), 0).toLocaleString()}` },
  ];

  return (
    <div style={{ maxWidth: 560 }}>
      <div className="page-header">
        <div>
          <div className="page-title">Settings</div>
          <div className="page-subtitle">$ configure workspace</div>
        </div>
      </div>

      {/* Stats */}
      <div className="card hover-blue" style={{ marginBottom: 8 }}>
        <div className="label" style={{ marginBottom: 12 }}>WORKSPACE_STATS</div>
        <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {stats.map(({ label, value }, i) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 0", borderBottom: i < stats.length - 1 ? "1px solid #0d0d0d" : "none" }}>
              <span className="mono" style={{ fontSize: 10, color: "#666" }}>{label}</span>
              <span className="mono" style={{ fontSize: 13, color: "#666" }}>{value}</span>
            </div>
          ))}
        </div>
      </div>

      {/* Investor dashboard sharing */}
      <div className="card hover-purple" style={{ marginBottom: 8 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
          <div>
            <div className="label" style={{ marginBottom: 2 }}>INVESTOR_DASHBOARD</div>
            <span className="mono" style={{ fontSize: 10, color: "#666" }}>share a live read-only view with investors</span>
          </div>
          <button
            className={`btn${shareEnabled ? " btn-green" : ""}`}
            onClick={handleToggleShare}
            disabled={shareLoading}
            style={{ fontSize: 10, minWidth: 60 }}
          >
            {shareLoading ? "..." : shareEnabled ? "on" : "off"}
          </button>
        </div>
        {shareEnabled && shareUrl && (
          <div style={{ display: "flex", gap: 6, marginTop: 4 }}>
            <div className="mono" style={{ flex: 1, fontSize: 10, color: "#555", background: "#050505", border: "1px solid #111", borderRadius: 6, padding: "7px 10px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
              {shareUrl}
            </div>
            <button className={`btn${copied ? " btn-green" : ""}`} onClick={handleCopy} style={{ fontSize: 10, flexShrink: 0 }}>
              {copied ? "✓ copied" : "copy"}
            </button>
          </div>
        )}
      </div>

      {/* About */}
      <div className="card">
        <div className="label" style={{ marginBottom: 8 }}>ABOUT</div>
        <p className="mono" style={{ fontSize: 11, color: "#666", lineHeight: 1.8 }}>
          greenline — financial clarity for startups.<br />
          track burn, runway, and team spend.
        </p>
        <div className="divider" />
        <span className="mono" style={{ fontSize: 10, color: "#1f1f1f" }}>v1.0.0 — data synced via firestore</span>
      </div>
    </div>
  );
}
